import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-extraction-product-program',
  templateUrl: './extraction-product-program.component.html',
  styleUrls: ['./extraction-product-program.component.scss']
})
export class ExtractionProductProgramComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
